import React, { useState } from 'react'
import { Button, Col, Row, Input, Alert } from 'reactstrap';
import 'animate.css';
import StepZilla from "react-stepzilla";
import { EventAmount } from './EventAmount'
import { CaptureAmount } from './CaptureAmount'
import "bootstrap-daterangepicker/daterangepicker.css";
import "moment/locale/es";
import DeniReactTreeView from 'deni-react-treeview';
import { Dialog } from 'primereact/dialog';



export const ModalEvent = (props) => {

    const {
        loadingPreview, modalTitle, toggleModalEvent, modalPreviewInvoice,
        start, end, setEnd, setStart, countSelected, amount_required, handleInputChange,
        saveProgrammingDiary, handleClose, title, validationsCreate, loadingViews,
        listBranchesTree, treeViewRef, onRenderItem, handleChangeAmount,
        onChangeItemtree, loadingProgramming
    } = props;

    //*PROGRAMMING EVENT MONTHLY
    const steps =
        [
            { name: 'Periodo de programación', component: <EventAmount start={start} end={end} setEnd={setEnd} setStart={setStart} handleInputChange={handleInputChange} title={title} loadingViews={loadingViews} /> },
            { name: 'Asignar montos a sucursales', component: <CaptureAmount amount_required={amount_required} handleInputChange={handleInputChange} treeViewRef={treeViewRef} listBranchesTree={listBranchesTree} handleChangeAmount={handleChangeAmount} onRenderItem={onRenderItem} onChangeItemtree={onChangeItemtree} /> },
        ]

    //*ALERT SAVE EVENT
    const AlertItem = props => {
        const { item } = props;
        const [Open, setOpen] = useState(true);

        return (
            <Alert className="alert-dismissible alert-color"
                color={item.alertcolor}
                isOpen={Open}
                target={"Alert-" + item.id}
            >
                {item.icon}
                <label className='f-14'>{item.alerttxt}</label>
            </Alert>
        );
    }


    return (
        <Dialog
            header="Programación del flujo B"
            visible={modalPreviewInvoice}
            modal
            dismissableMask
            onHide={toggleModalEvent}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
                content: { style: { paddingLeft: "1px" } }
            }}
            footer={
                <>
                    {
                        loadingPreview === false && <>
                            {

                                <div>
                                    <Button size="sm" className="btn-air-light" outline color="danger" onClick={handleClose} type="button" >Cerrar</Button>
                                    <Button size="sm" className="btn-air-light" outline color="secondary" onClick={() => saveProgrammingDiary()} type="button" >Autorizar</Button>
                                </div>
                            }
                        </>
                    }

                </>
            }
        >
            <Col sm="12" className='p-l-0 p-r-0 pt-3'>
                {
                    loadingPreview === true && <>
                        <Row className='mt-2'>
                            <Col sm="12" md="12" lg="12" className='text-center'>
                                <img src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '150px' }} />
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col sm="2" md="2" lg="2" className='text-center'></Col>
                            <Col sm="3" md="3" lg="3" className='text-left'>
                                <p className='f-24 text-primary'><b>Cargando</b></p>
                            </Col>
                            <Col sm="1" md="1" lg="1" className='text-center'></Col>
                            <Col sm="1" md="1" lg="1" className='text-center'>
                                <br />
                                <p className='animate__animated animate__fadeInDown animate__infinite text-info'><i className="fa fa-circle"></i></p>
                            </Col>
                            <Col sm="1" md="1" lg="1" className='text-center'>
                                <br />
                                <p className='animate__animated animate__fadeInDown animate__slow animate__infinite text-primary'><i className="fa fa-circle"></i></p>
                            </Col>
                            <Col sm="1" md="1" lg="1" className='text-center'>
                                <br />
                                <p className='animate__animated animate__fadeInDown animate__slower animate__infinite text-info'><i className="fa fa-circle"></i></p>
                            </Col>
                            <Col sm="2" md="2" lg="2" className='text-center'></Col>
                        </Row>
                    </>
                }
                {
                    loadingPreview === false && <>
                        {
                            <Col sm="12" className={loadingProgramming !== false ? "shadow-sm p-l-0 p-r-0 pt-1" : ""}
                                style={loadingProgramming !== false ? {
                                    backgroundColor: 'white', border: '1px solid #e0e0e0',
                                    borderRadius: '10px', padding: '12px', fontSize: '12px'
                                } : {}} >
                                {
                                    countSelected != 0 ?
                                        <Col sm="12" className='p-l-0 p-r-0 ' >
                                            {
                                                ((validationsCreate.amount_required || validationsCreate.title)) &&
                                                <AlertItem
                                                    item={
                                                        {
                                                            alerttxt: "Debes de llenar todos los campos requeridos para realizar su registro.",
                                                            alertcolor: 'danger inverse',
                                                            btnclose: 'default',
                                                            icon: <i className="icon-alert"></i>
                                                        }
                                                    }
                                                />
                                            }
                                            <Col sm="12" className='p-l-0 p-r-0 '>
                                                <div
                                                    style={{
                                                        color: "#856404",
                                                        fontSize: "0.78rem",
                                                        marginTop: "6px",
                                                        fontWeight: "500",
                                                        backgroundColor: "#fff3cd",
                                                        padding: "4px 10px",
                                                        borderRadius: "6px",
                                                        boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "6px",
                                                        border: "1px solid #ffeeba",
                                                    }}

                                                >
                                                    <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                                                    Para programar un evento es necesario generar el titulo de la programación y asignar al menos un monto en alguna sucursal.
                                                </div>
                                                <Row className='pt-3' >
                                                    <Col sm="5">
                                                        <label className='f-12 f-w-600' style={{ color: "#002940", fontSize: "13px" }} >Titulo *</label>
                                                        <br />
                                                        <input
                                                            type="text"
                                                            name="title"
                                                            value={title}
                                                            onChange={handleInputChange}
                                                            className={loadingViews === true ? "line-input" : "line-input"}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col sm="12" className='p-l-0 p-r-0 pt-3 pb-3' >
                                                <div className=''>
                                                    <Row>
                                                        <Col sm="4">
                                                            <label className='f-w-600 ' style={{ color: "#002940", fontSize: "13px" }} >Sucursales *</label>
                                                            <DeniReactTreeView
                                                                items={listBranchesTree}
                                                                ref={treeViewRef}
                                                                showCheckbox={true}
                                                                showIcon={false}
                                                                onRenderItem={onRenderItem}
                                                                style={{ marginRight: '10px', marginBottom: '10px', height: '240px', border: 'none' }}
                                                                onCheckItem={(e) => onChangeItemtree(e)}
                                                                className="deni-react-treeview-container-4"
                                                            />
                                                        </Col>
                                                        <Col sm="1">
                                                        </Col>
                                                        <Col sm="2">
                                                            <label style={{ color: "#002940", fontSize: "13px" }} className='f-w-600 '>Monto *</label>
                                                            {listBranchesTree?.map((_find, _key) => (
                                                                _find.children.map((_branch) => {
                                                                    return (
                                                                        <div key={_branch.id} className={`p-1 `}>
                                                                            <Input type='text' name="amount" value={_branch.amount} onChange={(e) => handleChangeAmount(e, _branch.id)} autoComplete='off'
                                                                                className={`form-control form-control-sm input-air-primary ${_branch?.state == 2 ? 'd-none' : ''}`} />
                                                                        </div>
                                                                    );
                                                                })
                                                            ))}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Col>
                                        :
                                        <div>
                                            {
                                                loadingProgramming === false ?
                                                    <StepZilla
                                                        steps={steps}
                                                        showSteps={true}
                                                        showNavigation={true}
                                                        stepsNavigation={true}
                                                        prevBtnOnLastStep={true}
                                                        dontValidate={true}
                                                        backButtonText="Anterior"
                                                        nextButtonText="Siguiente"
                                                    />
                                                    :
                                                    <div> <br />
                                                        <Row className='mt-2'>
                                                            <Col sm="12" md="12" lg="12" className='text-center'>
                                                                <img src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '150px' }} />
                                                            </Col>
                                                        </Row>
                                                        <Row className='mt-2'>
                                                            <Col sm="2" md="2" lg="3" className='text-center'></Col>
                                                            <Col sm="3" md="3" lg="4" className='text-right'>
                                                                <p className='f-22 text-primary'><b>Recopilando Información</b></p>
                                                            </Col>
                                                            <Col sm="1" md="1" lg="1" className='text-center'>
                                                                <br />
                                                                <p className='animate__animated animate__fadeInDown animate__infinite text-info'><i className="fa fa-circle"></i></p>
                                                            </Col>
                                                            <Col sm="1" md="1" lg="1" className='text-center'>
                                                                <br />
                                                                <p className='animate__animated animate__fadeInDown animate__slow animate__infinite text-primary'><i className="fa fa-circle"></i></p>
                                                            </Col>
                                                            <Col sm="1" md="1" lg="1" className='text-center'>
                                                                <br />
                                                                <p className='animate__animated animate__fadeInDown animate__slower animate__infinite text-info'><i className="fa fa-circle"></i></p>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                            }
                                        </div>
                                }
                            </Col>
                        }
                    </>
                }
            </Col>

        </Dialog>

    )

}
